/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class WorkloadFilter {
    getFixupPrototypeFunction() { return WorkloadFilter.fixupPrototype; }

    static newInstance(model: Partial<WorkloadFilter>): WorkloadFilter {
        let obj = Object.assign(new WorkloadFilter(), model);
        WorkloadFilter.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<WorkloadFilter>): WorkloadFilter {
        if (!model) return null;
        return WorkloadFilter.newInstance(<WorkloadFilter> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: WorkloadFilter) {
        if (!obj) return;

        models.WorkloadFilter.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: WorkloadFilter): boolean {
        Object.setPrototypeOf(obj, WorkloadFilter.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.query) {
            models.QueryOperator.fixupPrototype(this.query);
        }
    }

    /**
     * Tenant id
     */
    tenant_id: string;

    query: models.QueryOperator;

}
